import { compose, curryN } from 'ramda'
import { connect } from 'react-redux'

import { withTheme } from 'modules/util'
import { selectPart } from '../../../actions'
import { Strongest } from '../../../selectors'

import partsTheme from './theme.scss'

function mapStateToProps(state) {
  return {
    selected: Strongest.selected(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    handleSelect: curryN(2, compose(dispatch, selectPart))
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTheme(partsTheme)
)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Strongest/Parts/enhancers.js